<template>
  <div class="clubLives">
    <div class="clubLives__mainText">
      Чем живет <span>клуб?</span>
    </div>
    <div class="clubLives__text1">
      Закрытые встречи и кулуарные обсуждения «для своих».
    </div>
    <div class="clubLives__text2">
      Воркшопы, обучающие программы и совместные проекты.
    </div>
    <div class="clubLives__text3">
      Живые дискуссии и обмен инсайтами по OSINT, кибербезопасности и технологиям.
    </div>
    <div class="clubLives__text4">
      Неформальная дружеская атмосфера — мы верим, что общение и поддержка не менее важны, чем знания.
    </div>
  </div>
</template>

<script>
export default {
  name: "ClubLives"
}
</script>


<style scoped lang="scss">
.clubLives {
  font-family: var(--cd-default-font);
  font-size: 16px;
  font-weight: 400;

  // ── Desktop: artistic absolute-positioned layout ───────────────────────────
  @media (min-width: calc(#{$bp-lg} + 1px)) {
    min-height: 450px;
    position: relative;

    &__mainText {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      transform: translate(0, 42%);
    }

    $start_x: 210px;
    $start_y: 10px;

    &__text1 { width: 310px; top: $start_y; left: $start_x; }
    &__text2 { width: 341px; top: calc($start_y + 16px); left: calc($start_x + 495px); }
    &__text3 { width: 396px; top: calc($start_y + 250px); left: calc($start_x - 42px); }
    &__text4 {
      top: calc($start_y + 290px);
      left: calc($start_x + 495px);
      width: 400px;
      height: 134px !important;
      background: transparent !important;
      border: 1px solid var(--cd-text-muted-alt);
      text-transform: uppercase;
    }

    & [class^="clubLives__text"] {
      background: var(--cd-card-bg);
      position: absolute;
      height: 112px;
      border-radius: 20px;
      justify-content: center;
      display: flex;
      flex-direction: column;
      padding: 10px 24px;
    }
  }

  // ── Mobile/tablet: normal flow layout ─────────────────────────────────────
  @include respond-to('lg') {
    display: flex;
    flex-direction: column;
    gap: $space-sm;

    &__mainText {
      font-size: clamp(24px, 5vw, 36px);
      font-weight: bold;
      font-family: var(--cd-bold-font);
      color: var(--cd-highlight-text);
      margin-bottom: $space-sm;

      span { color: var(--cd-green); }
    }

    & [class^="clubLives__text"] {
      background: var(--cd-card-bg);
      border-radius: 20px;
      padding: 16px 24px;
    }

    &__text4 {
      background: transparent !important;
      border: 1px solid var(--cd-text-muted-alt);
      text-transform: uppercase;
    }
  }
}
</style>
